import React, { Fragment } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import type { ProductType } from '@atlassian/dynamic-cards-search-client/common/types';

import { getProductDisplayName } from '../../utils/product';
import { Show } from '../width-observer';

const metadataSpacerStyles = xcss({
	marginLeft: 'space.075',
	marginRight: 'space.075',
});

const Spacer = () => (
	<Box as="span" xcss={metadataSpacerStyles}>
		•
	</Box>
);

/** A metadata part to render */
type Part = string | null | [string, React.ReactNode];

const renderParts = (part: Part, spacer: boolean) => {
	const [key, value] = Array.isArray(part) ? part : [part, part];
	return (
		<Fragment key={key}>
			{value}
			{spacer && <Spacer />}
		</Fragment>
	);
};

const filterPart = (part: Part): boolean => {
	if (Array.isArray(part)) {
		return !!part[1];
	}
	return !!part;
};

export type SearchMetadataProps = {
	/** Nullish/empty string parts are filtered out. */
	parts?: Array<Part>;
	product?: ProductType;
	productSelected?: boolean;
};

export const SearchMetadata = ({
	product,
	productSelected,
	parts: defaultParts = [],
}: SearchMetadataProps): React.JSX.Element => {
	const productDisplayName = productSelected ? '' : getProductDisplayName(product);
	const parts = defaultParts.filter(filterPart);

	return (
		<>
			{productDisplayName && (
				<Show target="layout" above="sm">
					{productDisplayName}
					<Spacer />
				</Show>
			)}
			<>{parts?.map((m, i) => renderParts(m, i < parts.length - 1))}</>
		</>
	);
};
